<template>
  <QPage :style-fn="pageStyle">
    <slot />
  </QPage>
</template>

<script>
export default {
  name: "BasePage",
  methods: {
    pageStyle(offset, height) {
      const offsetHeight = `${height - offset}px`;

      return {
        minHeight: offsetHeight,
        height: offsetHeight,
      };
    },
  },
};
</script>
